<template>
  <div
    id="carouselExampleSlidesOnly"
    class="carousel slider mb-5 pt-5"
    data-bs-ride="carousel"
  >
    <div class="carousel-inner">
      <div
        class="carousel-item"
        v-bind:class="{ 'active': index == 0 }"
        v-for="(item, index) in data"
        :key="index"
      >
        <div
          class="img"
          :style="{
            'background-image': `url(${ rootImagePath +  item.imagePath })`,
          }"
        ></div>
      </div>
    </div>

 <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleSlidesOnly" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleSlidesOnly" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
    },
    rootImagePath: {
      type: String,
    },
  },
};
</script>
<style scoped>
.carousel {
  height: 100%;
}
.carousel-inner,
.carousel-item,
.slider .img {
  height: 100%;
}

.slider {
  width: 100%;
  margin-top:20px;
}

.slider .img {
  height: 100%;
  background-repeat: no-repeat;
  background-size:100% auto;
}

@media screen and (max-width: 700px) {
  .slider img {
    height: 200px !important;
  background-size: contain !important;

  }
  .carousel {
    height: 200px !important;
  }
}
</style>


